import { render, staticRenderFns } from "./player-games-list2.vue?vue&type=template&id=4124e2fc&"
import script from "./player-games-list2.vue?vue&type=script&lang=js&"
export * from "./player-games-list2.vue?vue&type=script&lang=js&"
import style0 from "./player-games-list2.vue?vue&type=style&index=0&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "player-games-list2.vue"
export default component.exports